import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { Trans } from '@lingui/react';
import { throughputUnitLabelFromThroughputControlType } from 'hooks/useDisplayUnits/display';
import { BasicDisplayUnits, unitLabels } from 'hooks/useDisplayUnits/useDisplayUnits';
import {
  PourDto,
  ThroughputControlType,
  UnitSystem,
  CustomUnitFields
} from 'providers/api';
import { round } from 'utils';
import UnitSystemDetail, { UnitSystemValue } from './ProjectAreaPage/ProjectStopesPage/StopePanelPage/RecipesTab/UnitSystemDetail';

interface PourHydraulicFillDetailsProps {
  pour: PourDto;
  unitSystemPreference: UnitSystem;
  throughputControlType: ThroughputControlType;
  customUnitFields: CustomUnitFields[];
}

const PourHydraulicFillDetails = ({
  pour,
  unitSystemPreference,
  throughputControlType,
  customUnitFields,
}: PourHydraulicFillDetailsProps) => (

  <>
    <UnitSystemDetail
      selected={pour.volume}
      unitSystem={unitSystemPreference}
      unitInfo={unitLabels[BasicDisplayUnits.Volume]}
      decimalPlaces={2}
      customUnitFields={customUnitFields}
    />

    <UnitSystemDetail
      designed={pour.hydraulicSpecification?.throughput}
      selected={pour.hydraulicSpecification?.throughput}
      unitSystem={unitSystemPreference}
      unitInfo={throughputUnitLabelFromThroughputControlType(throughputControlType)}
      decimalPlaces={2}
      customUnitFields={customUnitFields}
    />

    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Binder:Tailings">Binder:Tailings</Trans></TableCell>
      <TableCell align="right" width="auto">{`1:${round(100 / ((pour.hydraulicSpecification?.binderTailingsRatio ?? 0) * 100), 0)}`}</TableCell>
      <TableCell align="right">{`1:${round(100 / ((pour.hydraulicSpecification?.binderTailingsRatio ?? 0) * 100), 0)}`}</TableCell>
    </TableRow>

    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Concentration">Concentration</Trans></TableCell>
      <TableCell align="right" width="auto">{`${round(pour.hydraulicOptimisedSpecification?.massConcentration ?? 0, 2)} %m`}</TableCell>
      <TableCell align="right">{`${round(pour.hydraulicSelectedSpecification?.massConcentration ?? 0, 2)} %m`}</TableCell>
    </TableRow>

    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Settling Velocity">Settling Velocity</Trans></TableCell>
      <TableCell align="right" width="auto">{ }</TableCell>
      <TableCell align="right">
        <UnitSystemValue
          value={pour.hydraulicSelectedSpecification?.settlingVelocity}
          unitSystem={unitSystemPreference}
          unitInfo={unitLabels[BasicDisplayUnits.Speed]}
          decimalPlaces={2}
          customUnitFields={customUnitFields}
        />
      </TableCell>
    </TableRow>

    <TableRow>
      <TableCell component="th" scope="row"><Trans id="Minimum Velocity">Minimum Velocity</Trans></TableCell>
      <TableCell align="right" width="auto">{ }</TableCell>
      <TableCell align="right">
        <UnitSystemValue
          value={pour.hydraulicSelectedSpecification?.minVelocity}
          unitSystem={unitSystemPreference}
          unitInfo={unitLabels[BasicDisplayUnits.Speed]}
          decimalPlaces={2}
          customUnitFields={customUnitFields}
        />
      </TableCell>
    </TableRow>
  </>
);
export default PourHydraulicFillDetails;
